/**
 * Shared ownership of `document.body.dataset.modalOpen`.
 *
 * App.js's global keydown handler (Escape deselects, Delete removes the selected
 * block) bails out whenever that attribute is present, so every overlay that
 * covers the page has to set it. Five of them do: AdminGate, BlockPickerModal,
 * the carousel Lightbox, the mobile sidebar drawer and SidebarSettingsPanel.
 *
 * A plain boolean broke as soon as two overlays were open at once — the first to
 * close deleted the flag while the other was still up, and Delete silently began
 * destroying blocks behind it again. The counter below makes the flag stay set
 * until the last holder releases it.
 *
 * Usage: `useEffect(() => acquireModalLock(), [])` — the returned release
 * function is the effect's cleanup, so unmount is handled for free.
 */
let openCount = 0;

export function acquireModalLock() {
  openCount += 1;
  document.body.dataset.modalOpen = 'true';

  let released = false;
  return function releaseModalLock() {
    // Idempotent: StrictMode's double-invoked effects must not underflow.
    if (released) return;
    released = true;
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) delete document.body.dataset.modalOpen;
  };
}
